import { formatDateTime } from "@/utils/helper/formatDate";
import { FieldProperties } from "alurkerja-ui/dist/types";
import { Anchor } from "../ui/anchor";
import { STATUS } from "@/utils/constant";
import { statusVariantMap } from "../ui/data-info";
import { Badge } from "../ui/badge";
import { formatMonth } from "@/utils/helper/formatMonth.ts";

export type TableCellProps = {
  name: string;
  fields: {
    [x: string]: FieldProperties;
  };
  value: unknown;
  rowValue: {
    [x: string]: unknown;
  };
  defaultCell: React.JSX.Element;
  rowIndex: number;
};

export function TableCell({
  name,
  value,
  rowValue,
  defaultCell,
}: TableCellProps) {
  if (name === "custom_action") {
    const statusRfs = rowValue.statusRfsSubmission;
    const isRevise = statusRfs === STATUS.RFS.REVISION_DATA;

    const href = isRevise ? `./${rowValue.id}/draft` : `./${rowValue.id}`;

    return (
      <div className="flex justify-center">
        <Anchor mood="axiata-blue-link" href={href}>
          {isRevise ? "Revision" : "Detail"}
        </Anchor>
      </div>
    );
  }

  if (name === "trackerdataApd.tenantName") {
    return (
      <>
        {(rowValue.trackerdataApd as { tenantName: string })?.tenantName ?? "-"}
      </>
    );
  }

  if (name === "trackerdataApd.vendor") {
    return (
      <>{(rowValue.trackerdataApd as { vendor: string })?.vendor ?? "-"}</>
    );
  }

  if (name === "active") {
    return <>{rowValue.active ? "Active" : "Inactive"}</>;
  }

  if (value === null || value === undefined) {
    return <>-</>;
  }

  if (name === "description") {
    return (
      <span className="block max-w-xs truncate" title={value as string}>
        {value as string}
      </span>
    );
  }

  if (name === "picVendor" || name === "picLinknet") {
    return <>{(value as { username: string }).username ?? "-"}</>;
  }

  if (name === "statusRfsSubmission" || name === "status") {
    const variantBadge =
      statusVariantMap[value as keyof typeof statusVariantMap] || "default";
    return (
      <Badge variant={variantBadge} className="whitespace-nowrap">
        {value as string}
      </Badge>
    );
  }

  if (name === "createdDate" || name === "updatedDate") {
    return (
      <span className="whitespace-nowrap">
        {formatDateTime(value as string)}
      </span>
    );
  }

  if (name === "monthTarget") {
    return (
      <span className="whitespace-nowrap">{formatMonth(value as number)}</span>
    );
  }

  return defaultCell;
}
